import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './activityblock.module.scss';
import { useEffect, useState } from 'react';
import { fetchActivityInfo } from '../../../services/api'; // Новая функция

const ActivityBlock = () => {
    const { settings } = useAccessibility();
    const [activityData, setActivityData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchActivityInfo();
                // Данные теперь в response.data[0].attributes
                setActivityData(response.data[0].attributes);
                console.log('Activity data:', response.data[0].attributes);
            } catch (err) {
                console.error('Error fetching activity data:', err);
                setError('Не удалось загрузить данные о деятельности');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // File link component
    const FileLink = ({ file, label, fallbackUrl, fallbackExt }) => {
        if (file?.data?.attributes?.url) {
            return (
                <Link
                    href={`${file.data.attributes.url}`}
                    children={`${label} (${file.data.attributes.ext || 'PDF'})`}
                    color={linkColor}
                    aria-label={`Скачать документ: ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            );
        }
        if (fallbackUrl) {
            return (
                <Link
                    href={fallbackUrl}
                    children={`${label} (${fallbackExt})`}
                    color={linkColor}
                    aria-label={`Скачать документ: ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            );
        }
        return null;
    };

    if (loading) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='ФИНАНСОВО-ХОЗЯЙСТВЕННАЯ ДЕЯТЕЛЬНОСТЬ'
            headerColor={textColor}
        >
            <div>Загрузка данных о деятельности...</div>
        </Block>
    );

    if (error) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='ФИНАНСОВО-ХОЗЯЙСТВЕННАЯ ДЕЯТЕЛЬНОСТЬ'
            headerColor={textColor}
        >
            <div>{error}</div>
        </Block>
    );

    if (!activityData) return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='200px'
            background={backgroundColor}
            header='ФИНАНСОВО-ХОЗЯЙСТВЕННАЯ ДЕЯТЕЛЬНОСТЬ'
            headerColor={textColor}
        >
            <div>Данные не найдены</div>
        </Block>
    );

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='ФИНАНСОВО-ХОЗЯЙСТВЕННАЯ ДЕЯТЕЛЬНОСТЬ'
            headerColor={textColor}
            id='activity'
            aria-label="Финансово-хозяйственная деятельность"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        {/* Государственное задание */}
                        <section aria-labelledby="goverment-task">
                            <h3 id="goverment-task" className={style.sectionHeader} style={{ color: textColor }}>
                                Государственное задание
                            </h3>
                            
                            <div className={style.fileList}>
                                {activityData.GovermentTaskFile?.length > 0 ? (
                                    activityData.GovermentTaskFile.map((item) => (
                                        item.GovermentTaskFile?.data?.attributes && (
                                            <div key={item.id} className={style.fileItem}>
                                                <Link
                                                    href={`${item.GovermentTaskFile.data.attributes.url}`}
                                                    children={`${item.GovermentTaskFile.data.attributes.name} (${item.GovermentTaskFile.data.attributes.ext || 'PDF'})`}
                                                    color={linkColor}
                                                    fontFamily='Roboto, sans-serif'
                                                    fontSize='1rem'
                                                    fontWeight='500'
                                                    aria-label={`Скачать: ${item.GovermentTaskFile.data.attributes.name}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                />
                                                {item.GovermentTaskFile.data.attributes.year && (
                                                    <span className={style.fileYear}>
                                                        {item.GovermentTaskFile.data.attributes.year} год
                                                    </span>
                                                )}
                                            </div>
                                        )
                                    ))
                                ) : (
                                    <p style={{ fontStyle: 'italic', color: '#666' }}>
                                        Документы государственного задания временно недоступны
                                    </p>
                                )}
                            </div>
                        </section>

                        {/* Финансовые документы */}
                        <section aria-labelledby="financial-docs">
                            <h3 id="financial-docs" className={style.sectionHeader} style={{ color: textColor }}>
                                Финансовые документы
                            </h3>
                            
                            <div className={style.fileList}>
                                {activityData.FinancialData?.length > 0 ? (
                                    activityData.FinancialData.map((item) => (
                                        item.FinancialData?.data?.attributes && (
                                            <div key={item.id} className={style.fileItem}>
                                                <Link
                                                    href={`${item.FinancialData.data.attributes.url}`}
                                                    children={`${item.FinancialData.data.attributes.name} (${item.FinancialData.data.attributes.ext || 'PDF'})`}
                                                    color={linkColor}
                                                    fontFamily='Roboto, sans-serif'
                                                    fontSize='1rem'
                                                    fontWeight='500'
                                                    aria-label={`Скачать: ${item.FinancialData.data.attributes.name}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                />
                                                {item.FinancialData.data.attributes.year && (
                                                    <span className={style.fileYear}>
                                                        {item.FinancialData.data.attributes.year} год
                                                    </span>
                                                )}
                                            </div>
                                        )
                                    ))
                                ) : (
                                    <p style={{ fontStyle: 'italic', color: '#666' }}>
                                        Финансовые документы временно недоступны
                                    </p>
                                )}
                            </div>
                        </section>
                    </div>
                </div>
            </FadeIn>
        </Block>
    )
}

export default ActivityBlock;